import client from './client'
import {
  UserInfo,
  WeChatInfo,
  UpdateUserInfo,
  UserVerification,
  UserVerificationInfo,
  Organizationinfo,
  ListResponse,
  PermissionInfo,
  SecurityProfile,
  SecurityGate,
  SecurityOptions,
  SecurityWechatInfo,
  SecurityWechatStatus,
} from '@/types'

export const getUserInfo = () => {
  return client<UserInfo>({
    method: 'get',
    url: 'user/profile',
  })
}

export const updateUserName = (data: { nickname: string; head_img_url?: string }) => {
  return client<unknown>({
    method: 'put',
    url: 'user/profile',
    data,
  })
}

export const getSecurityProfile = () => {
  return client<SecurityProfile>({
    method: 'get',
    url: 'user/security/profile',
  })
}

export const getSecurityGate = (scene: string) => {
  return client<SecurityGate>({
    method: 'get',
    url: 'user/security/gate',
    params: { scene },
  })
}

export const getSecurityOptions = (scene: string) => {
  return client<SecurityOptions>({
    method: 'get',
    url: 'user/security/options',
    params: { scene },
  })
}

export const getSecurityWechatInfo = (scene: string) => {
  return client<SecurityWechatInfo>({
    method: 'get',
    url: 'user/security/wechat',
    params: { scene },
  })
}

export const getSecurityWechatStatus = (scene: string, state: string) => {
  return client<SecurityWechatStatus>({
    method: 'get',
    url: 'user/security/wechat/status',
    params: { scene, state },
  })
}

export const bindMail = (data: {
  code: string
  mail: string
  verify_type?: 'phone' | 'email' | 'wechat'
  verify_code?: string
  verify_password?: string
  verify_state?: string
}) => {
  return client({
    url: 'user/profile/bind/mail',
    method: 'put',
    data,
  })
}

export const getBindMailCode = (data: { mail: string; scene?: string }) => {
  return client({
    url: 'user/bind/mail',
    method: 'post',
    data,
  })
}

export const bindMobile = (data: { phone_number: string; code: string }) => {
  return client({
    url: 'user/profile/bind/mail',
    method: 'put',
    data,
  })
}

export const getBindMobileCode = (data: { phone_number: string }) => {
  return client({
    url: 'user/bind/mail',
    method: 'post',
    data,
  })
}

export const bindWeChatInfo = () => {
  return client<WeChatInfo>({
    url: 'user/bind/wechat',
    method: 'get',
  })
}

export const updatePassword = (data: UpdateUserInfo) => {
  return client({
    url: 'user/password',
    method: 'put',
    data,
  })
}

export const userVerification = (data: UserVerification) => {
  return client<{ url: string; code: 0 | 1000 | 1001; second: number }>({
    url: 'apply/alipay/cert-url',
    method: 'post',
    data,
  })
}

export const checkVerification = () => {
  return client<UserVerificationInfo>({ url: 'user/certify', method: 'get' })
}

export const getUserOrganizations = (params?: { privilege: 'manager' | 'all' }) => {
  return client<ListResponse<Organizationinfo>>({
    url: 'user/organizations',
    method: 'get',
    params,
  })
}

export const getUerPermissions = (id: number) => {
  return client<ListResponse<PermissionInfo>>({
    url: `organizations/${id}/mine/permissions`,
    method: 'get',
  })
}

// kind: 1 登录 2 绑定 3 换绑 4 重置密码 5 安全校验
export const postUserPhoneCode = (data: { phone: string; kind: 1 | 2 | 3 | 4 | 5 }) => {
  return client({
    url: 'user/phone/code',
    method: 'post',
    data,
  })
}

export const postUserPhoneBind = (data: { phone: string; code: string }) => {
  return client({
    url: 'user/phone/bind',
    method: 'post',
    data,
  })
}

export const postUserPhoneChange = (data: {
  verify_type: 'phone' | 'email' | 'wechat'
  verify_code?: string
  verify_password?: string
  verify_state?: string
  new_phone: string
  new_code: string
}) => {
  return client({
    url: 'user/phone/change',
    method: 'post',
    data,
  })
}

export const putUserPassword = (data: {
  verify_type: 'phone' | 'email' | 'password' | 'wechat'
  verify_code?: string
  verify_password?: string
  verify_state?: string
  new_password: string
  confirm_password: string
}) => {
  return client({
    url: 'user/password',
    method: 'put',
    data,
  })
}

export const deleteUserCloseAccount = (data: {
  verify_type: 'phone' | 'email' | 'password' | 'wechat'
  verify_code?: string
  verify_password?: string
  verify_state?: string
  confirmation_text: string
}) => {
  return client({
    url: 'user/close_account',
    method: 'delete',
    data,
  })
}

export const postUserAvatar = (file: File) => {
  const formData = new FormData()
  formData.append('images', file)
  return client<{ head_img_url: string }>({
    url: 'user/avatar',
    method: 'post',
    data: formData,
  })
}
